import { keyframes } from '@mui/material/styles';

import { Box } from '@occc-app/design-system';
import { Drive_Response_Reaction } from '@occc/graphql';

import { messageComponents, DefaultMessage } from './message-types';

import type { ChatMessage as ChatMessageType } from '../../types';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeInUpAnimation = {
  animation: `${fadeInUp} 250ms ease-out`,
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
};

const promptContainerSx = {
  display: 'flex',
  justifyContent: 'flex-end',
  ...fadeInUpAnimation,
};

const messageContainerSx = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1.5,
  minWidth: 0,
  ...fadeInUpAnimation,
};

type ChatMessageProps = {
  message: ChatMessageType;
  onReactionChange?: (responseId: string, reaction: Drive_Response_Reaction | null) => void;
  onRetry?: () => void;
  streamingStatusText?: string | null;
};

export const ChatMessage = ({
  message,
  onReactionChange,
  onRetry,
  streamingStatusText,
}: ChatMessageProps) => {
  const MessageComponent = messageComponents[message.type] ?? DefaultMessage;
  const containerSx = message.type === 'prompt' ? promptContainerSx : messageContainerSx;

  return (
    <Box sx={containerSx}>
      <MessageComponent
        message={message}
        onReactionChange={onReactionChange}
        onRetry={onRetry}
        streamingStatusText={streamingStatusText}
      />
    </Box>
  );
};
